<template>
  <div class="animated fadeIn">
    <Row>
      <Input v-model="keywordFilter" placeholder="用户名/用户昵称/真实姓名/电话" style="width: 200px; margin-right: 10px;"></Input>
      <Button type="primary" style="margin-right: 10px;" @click="onFilterClick">查询</Button>
      <Button type="primary" @click="addUserModal=true">添加用户</Button>
    </Row>
    <Row style="margin-top: 10px;">
      <div>
        <div style="position:relative;">
          <Table height="600" :columns="columns" :stripe="true" :data="content" ref="table" :height="tableHeight"
                 @on-sort-change="sortChange"></Table>
          <div style="position:absolute;top:0px;width:100%;height:100%;display: flex;
                            align-items: center;
                            justify-content: center;background: rgba(210, 216, 222, 0.5);" v-if="listLoadding">
            <Spin size="large"></Spin>
            <h6 style="color:#2d8cf0;margin-top:10px;">正在获取数据...</h6>
          </div>
        </div>
        <Page :total="totalElements" :page-size="pageSize" :show-total="true" show-elevator @on-change="setPage"
              style="text-align:right;margin-top:10px;"></Page>

      </div>
    </Row>
    <set-role-modal v-model="setRoleModal" :initValue="setRoleUserId"></set-role-modal>
    <add-user-modal v-model="addUserModal" @on-success="onSuccess"></add-user-modal>
    <user-detail-modal v-model="userDetailModal" :initValue="userDetailId" @on-success="onSuccess"></user-detail-modal>
  </div>
</template>

<script>
  import SetRoleModal from '@/view/acl/components/set-role-modal'
  import AddUserModal from '@/view/acl/components/add-user-modal'
  import UserDetailModal from '@/view/acl/components/user-detail-modal'

  import Vue from 'vue'
  import store from '@/store'
  import {mapActions} from 'vuex'
  import {genQueryParam, genSortParam} from '@/libs/queryparamhelper'

  export default {
    name: 'users',
    components: {
      SetRoleModal,
      AddUserModal,
      UserDetailModal
    },
    data() {
      return {

        // 添加用户
        addUserModal:false,

        // 设置角色
        setRoleModal:false,
        setRoleUserId:null,

        // 用户详细信息
        userDetailModal:false,
        userDetailId:null,

        keywordFilter:null,
        tableHeight: 160,
        pageIndex: 1,
        sort: null,
        listLoadding: false,

        columns: [
          {
            title: 'ID',
            key: 'id',
            sortable: 'custom',
            tooltip: 'true',
            minWidth: 100
          },
          {
            title: '用户名',
            key: 'name',
            ellipsis: 'true',
            minWidth: 200
          },
          {
            title: '昵称',
            key: 'nickName',
            ellipsis: 'true',
            minWidth: 200
          },
          {
            title: '真实姓名',
            key: 'realName',
            ellipsis: 'true',
            minWidth: 160
          },
          {
            title: '头像',
            key: 'avatarUrl',
            ellipsis: 'true',
            minWidth: 100,
            render: function (h, params) {
              if (params.row.avatarUrl) {
                return h('img',
                  {
                    attrs: {src: params.row.avatarUrl},
                    style: {width: '45px', height: '45px'}
                  });
              }
            }
          },
          {
            title: '性别',
            sortable: 'custom',
            ellipsis: 'true',
            key: 'sex',
            minWidth: 90,
            render: function (h, params) {
              if(params.row.sex===1){
                return h('div', '男')
              }else if(params.row.sex===0){
                return h('div', '女')
              }else{
                return h('div', '未知')
              }
            }
          },
          {
            title: '电话',
            key: 'mobilePhoneNum',
            sortable: 'custom',
            ellipsis: 'true',
            minWidth: 120
          },
          {
            title: '注册时间',
            sortable: 'custom',
            ellipsis: 'true',
            tooltip: 'true',
            key: 'createDate',
            minWidth: 180,
            render: function (h, params) {
              if (params.row.createDatetime) {
                let d = new Date(params.row.createDatetime)
                return h('div', d.Format('yyyy年MM月dd日 hh:mm:ss'))
              }
            }
          },
          {
            title: '最后登录时间',
            sortable: 'custom',
            ellipsis: 'true',
            tooltip: 'true',
            key: 'lastLoginDatetime',
            minWidth: 180,
            render: function (h, params) {
              if (params.row.lastLoginDatetime) {
                let d = new Date(params.row.lastLoginDatetime)
                return h('div', d.Format('yyyy年MM月dd日 hh:mm:ss'))
              }
            }
          },
          {
            title: '状态',
            tooltip: 'true',
            minWidth: 120,
            render: (h, params) => {
              const task_status = params.row.state;
              if (task_status == 1)
                return h('div', [
                  h('Tag', {
                    props: {
                      type: 'dot',
                      color: 'green'
                    }
                  }, '正常'),
                ]);

              else if (task_status == 2)
                return h('div', [
                  h('Tag', {
                    props: {
                      type: 'dot',
                      color: 'red'
                    }
                  }, '禁用'),
                ]);
            }
          },

          {
            title: '操作',
            key: 'action',
            align: 'left',
            ellipsis: 'true',
            minWidth: 350,
            render: (h, params) => {
              const task_status = params.row.deleted;
              if (task_status === false) {
                return h('div', [
                  h('strong', {
                    style: {
                      marginRight: '5px'
                    }
                  }, '禁用'),
                  h('i-switch', {
                      style: {
                        marginRight: '10px'
                      },
                      props: {
                        type: 'primary',
                        value: params.row.state == 1 ? false : true
                      },
                      on: {
                        'on-change': (val) => {

                          let disp = ''
                          let state = 0

                          if (val) {
                            state = 1
                            disp = '<p>确认禁用该用户账号</p>'
                          } else {
                            state = 0
                            disp = '<p>确认解禁该用户账号</p>'
                          }

                          // if (params.row.state == false) {
                          this.$Modal.confirm({
                            title: '确认改变用户状态',
                            content: disp,
                            onOk: () => {
                              store.dispatch('UserServ_Disable', {
                                params: {id: params.row.id, disable: state}
                              }).then(() => {
                                this.$Message.success('修改成功')
                                this.refreshPage()
                              }).catch(err => {
                                this.$Message.error(err)
                                this.refreshPage()
                              })
                            },
                            onCancel: () => {
                              this.refreshPage()
                            }
                          });
                          // }
                        }
                      }
                    }, ''
                  ),
                  h('Button', {
                    props: {
                      type: 'primary',
                      size: 'small',
                      disabled: false,
                    },
                    style: {
                      marginRight: '5px'
                    },
                    on: {
                      click: () => {
                        console.log('this.setRoleModal = true')
                        this.setRoleUserId = params.row.id
                        this.setRoleModal = true
                      }
                    }
                  }, '设置角色'),
                  h('Button', {
                    props: {
                      type: 'primary',
                      size: 'small',
                      disabled: false,
                    },
                    style: {
                      marginRight: '5px'
                    },
                    on: {
                      click: () => {
                        this.onResetPasswordBtnClick(params.row.id)
                      }
                    }
                  }, '重置密码'),
                  h('Button', {
                    props: {
                      type: 'primary',
                      size: 'small',
                      disabled: false,
                    },
                    style: {
                      marginRight: '5px'
                    },
                    on: {
                      click: () => {
                        this.userDetailId = params.row.id
                        this.userDetailModal = true
                      }
                    }
                  }, '详细信息')
                ])
              } else if (task_status === true) {
                return h('div', [
                  h('Button', {
                    props: {
                      type: 'primary',
                      size: 'small',
                    },
                    style: {
                      marginRight: '5px'
                    },
                    on: {
                      click: () => {
                        this.onActiveBtnClick(params.row.id)
                      }
                    }
                  }, '激活')
                ]);
              }
            }//render
          },//{
        ]//cloumn
      }//return
    },//data
    methods: {
      ...mapActions([
        'getUserInfo',
        'UserServ_GetPage',
        'UserServ_SetRoles',
        'UserServ_GetRoles',
        'RoleServ_GetAll',
        'UserServ_ResetPassword',
        'UserServ_ActiveUser',
        'UserServ_Disable'
      ]),
      onSuccess(){
        this.setPage(1)
      },
      onFilterClick(){
        this.setPage(1)
      },
      onResetPasswordBtnClick(userId) {
        this.$Modal.confirm({
          title: '重置密码',
          content: '<p>是否确认重置此用户密码</p>',
          onOk: () => {
            store.dispatch('UserServ_ResetPassword', {params: {userId: userId}}).then(() => {
              this.$Message.success('重置密码成功')
            }).catch(err => {
              this.$Message.error(err)
            })
          },
          onCancel: () => {
          }
        })
      },
      sortChange({column, key, order}) {
        this.sort = {
          name: key,
          asc: order === 'asc' ? true : false
        }
        this.refreshPage()
      },
      setPage(page) {
        console.log('setPage' + page)
        this.pageIndex = page
        this.listLoadding = true

        let sortParam = null

        if (this.sort !== null && this.sort !== undefined) {
          sortParam = genSortParam(this.sort.name, this.sort.asc)
        } else {
          sortParam = genSortParam('id', false)
        }

        store.dispatch('UserServ_GetPage', {
          params: null,
          urlparams: {
            p: page,
            keyword: this.keywordFilter,
            sort: sortParam
          }
        }).then(() => {
          this.listLoadding = false
        }).catch(err => {
          this.listLoadding = false
          this.$Message.error(err)
        });
      },
      //刷新当前页
      refreshPage() {
        this.setPage(this.pageIndex)
      }
    },
    computed: {
      totalElements() {
        if (store.getters.get_User_GetPageResult) {
          return store.getters.get_User_GetPageResult.totalElements
        } else {
          return 0
        }
      },
      content() {
        if (store.getters.get_User_GetPageResult) {
          return store.getters.get_User_GetPageResult.content
        } else {
          return []
        }
      },
      pageSize() {
        if (store.getters.get_User_GetPageResult) {
          return store.getters.get_User_GetPageResult.size
        } else {
          return 0
        }
      }
    },
    mounted() {
      this.$nextTick(() => {
        this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 230;
        this.setPage(1)
      });
    },
  }
</script>

<style scoped>
</style>
